import axios from 'axios';
import React, { useState, useEffect, useMemo, Fragment, useRef } from 'react';

import { FormControl, InputLabel, Input, FormHelperText, Alert, TableContainer, Badge } from '@mui/material';
import WebService from '@util/webService';
import { encodeParams, getAction } from '@util/helper';
// redux
import { useSelector, useDispatch } from 'react-redux';
// MUI Table
import CssBaseline from '@mui/material/CssBaseline';
import MUITable from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableFooter from '@mui/material/TableFooter';
import Paper from '@mui/material/Paper'
// react-table
import { useTable, useExpanded } from 'react-table';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { Checkbox, FormGroup, FormControlLabel, Typography, Snackbar, TablePagination, TextField, withStyles, InputBase } from '@mui/material';
import {tablePaginationClasses} from '@mui/material/TablePagination'
import { styled, alpha } from '@mui/material/styles';
import '@scss/App.scss';
import Button from '@mui/material/Button';
import FlatButton from '@components/FlatButton';
import useSnackbar from '@hooks/useSnackbar';
import MyTableHead from '@components/MyTableHead';
import useIndicator from '@hooks/useIndicator';
import Indicator from '@components/Indicator';
import MyDialog2 from '@components/MyDialog2';
import useDelegate from "@hooks/useDelegate";
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
// pagination
import { useTheme } from '@mui/material/styles';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { useNavigate, useLocation } from 'react-router-dom';
import moment from 'moment';
import { Avatar, Grid, Container } from '@mui/material/';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { searchSchool, truncate } from '@util/helper';
import ManagerStudentPart from './manager-student.part';
import ManagerStudentPart2 from './manager-student.part2';
import useAlert from "@hooks/useAlert";
import {useParams} from "react-router-dom";
import ConfirmDialog from "@components/ConfirmDialog";
import * as ExcelJS from 'exceljs'
import { useLoading } from '@context/LoadingContext';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { EditOutlined } from '@mui/icons-material'
const Boxs = styled(Box)`
  padding-bottom: 40px !important;
`;

const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`;

const ManagerStudentPage = () => {
  console.log('ManagerStudentPage rendering...');
  const inputRef = useRef();
  const defUrl = '/student';
  const dateFormat = 'YYYY-MM-DD HH:mm:ss';
  const [detailScreen, set_detailScreen] = useState(false);
  const navigate = useNavigate()
  const location = useLocation()
  const curLocationRef = useRef(location)
  const {alert, renderAlert} = useAlert()
  const {more} = useParams()
  const {setLoading} = useLoading()
  const dgRef = useRef() 
  const remarkRef = useRef()
  const fields = [
    { field: 'id', placeholder: '', type: 'text', value: -1, visible: more && (more === 'more'), canSrch: false, selList: [] },
    { field: 'name', placeholder: '이름', type: 'text', value: '', visible: true, canSrch: true, selList: [], width:200 },
    { field: 'schoolId', placeholder: '학교명', type: 'auto', value: '', visible: more && (more === 'more'), canSrch: true, selList: []},
    { field: 'grade', placeholder: '학년', type: 'number', value: '', visible: true, canSrch: true, selList: [], width:100,},
    { field: 'className', placeholder: '반', type: 'text', value: '', visible: true, canSrch: true, selList: [], width:100 },
    { field: 'classNum', placeholder: '번호', type: 'number', value: '', visible: true, canSrch: false, selList: [], width:100 },
    { field: 'gdnPhone', placeholder: '보호자 전화 번호', type: 'number', value: '', visible: true, canSrch: true, selList: [], width:300 },
    { field: 'ftYn', placeholder: '자유수강권', type: 'text', value: 'N', visible: true, canSrch: true, selList: ['Y', 'N'], width:100 },
    { field: 'gdnCertYn', placeholder: '보호자가입', type: 'text', value: 'N', visible: !detailScreen, canSrch: true, selList: ['Y', 'N'], width:100 },
    { field: 'remark', placeholder: '비고', type: 'text', value: '', visible: true, canSrch: false, selList: [], },
  ];

  // const [fields, set_fields] = useState([...defFields])

  const visibleColumns = fields.filter(col => col.visible);
  const defRecord = {};
  fields.forEach(d => {
    defRecord[d.field] = d.value;
  });
  defRecord.schoolList = [];
  const defTerms = {};
  fields
    .filter(col => col.canSrch)
    .map(d => d.field)
    .forEach(d => (defTerms[d] = ''));
  const [dataList, set_dataList] = useState([]);

  const [skipPageReset, setSkipPageReset] = React.useState(false);
  const [openSnackbar, renderSnackbar] = useSnackbar();
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator();
  const [selIdx, set_selIdx] = useState(-1);
  const [pageNum, set_pageNum] = useState(0);
  const [pageSize, set_pageSize] = useState(10);
  const [totalCount, set_totalCount] = useState(0);
  const [pageInfo, set_pageInfo] = useState({ pageNum: 0, pageSize: 10 });
  const [terms, _set_terms] = useState(defTerms);
  const termsRef = useRef(terms);
  const [fontSize, set_fontSize] = useState(12);
  const [open, set_open] = useState(false);
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer);
  const codes = useSelector(state => state.codeReducer);
  const schools = useSelector(state => state.schoolReducer);
  const account = useSelector(state => state.accountReducer);
  const schola = useSelector(state => state.scholaReducer);
  const searchButtonRef = useRef(null)

  const searchRefMap = useMemo(() => [], [location])
  fields.filter(r => r.canSrch).forEach(f => {
    searchRefMap[f.field] = useRef()
  })

  //
  const recordRef = useRef(defRecord)
  const uptRef = useRef(false)
  const set_terms = data => {
    termsRef.current = data;
    _set_terms(data)
  };

  const fetchStudents = async (pageNum, pageSize, terms) => {
    const schoolId = schola.hasOwnProperty('id') ? schola.id : -1;
    let url = `/student/school/${schoolId}`;
    const newTerms = {};
    Object.keys(termsRef.current).forEach(key => {
      if (termsRef.current[key] !== '') {
        newTerms[key] = termsRef.current[key];
      }
    });

    let tempList;
    openIndicator();
    let resp = await WebService.get(url, {
      pageNum: pageNum,
      pageSize: pageSize,
      terms: terms
    });
    closeIndicator();

    if (resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage);
      const records = JSON.parse(repMessage.records);
      const totalCount = repMessage.totalCount;
      set_totalCount(totalCount);
      records.forEach(r => {
        r.isDetail = false;
        r.gdn = { id: -1 };
        r.regiAndLectureList = [];
        r.gdnCertYn = ''
        if(r.user) {
          if(r.user.phoneCertYn== 'Y') {
            if(r.user.emailCertYn == 'Y') {
              r.gdnCertYn = 'Y'
            }
            else {
              r.gdnCertYn = 'P'
            }
          }
        }
      });

      // set_dataList(records)
      tempList = records;
    }

    tempList.forEach(st => {
      const found = schools.find(d => d.id === st.schoolId);
      if (found) {
        st.schoolName = found.name;
      }
    });

    return tempList
    // set_dataList(tempList);

  }

  const onLoad = async () => {
    const newTerms = {};
    Object.keys(termsRef.current).forEach(key => {
      if (termsRef.current[key] !== '') {
        newTerms[key] = termsRef.current[key];
      }
    });
    const dataList = await fetchStudents(pageInfo.pageNum, pageInfo.pageSize, JSON.stringify(newTerms)) 
    set_dataList(dataList)
    /*
    openIndicator();

    const schoolId = schola.hasOwnProperty('id') ? schola.id : -1;
    let url = `/student/school/${schoolId}`;
    const newTerms = {};
    Object.keys(termsRef.current).forEach(key => {
      if (termsRef.current[key] !== '') {
        newTerms[key] = termsRef.current[key];
      }
    });

    let tempList;
    let resp = await WebService.get(url, {
      pageNum: pageInfo.pageNum,
      pageSize: pageInfo.pageSize,
      terms: JSON.stringify(newTerms),
    });
    if (resp.repCode === 'reject') {
      navigate('/login');
      return;
    }

    if (resp.repCode === 'ack') {
      const repMessage = JSON.parse(resp.repMessage);
      const records = JSON.parse(repMessage.records);
      const totalCount = repMessage.totalCount;
      set_totalCount(totalCount);
      records.forEach(r => {
        r.isDetail = false;
        r.gdn = { id: -1 };
        r.regiAndLectureList = [];
        r.gdnCertYn = ''
        if(r.user) {
          if(r.user.phoneCertYn== 'Y') {
            if(r.user.emailCertYn == 'Y') {
              r.gdnCertYn = 'Y'
            }
            else {
              r.gdnCertYn = 'P'
            }
          }
        }
      });

      // set_dataList(records)
      tempList = records;
    }

    tempList.forEach(st => {
      const found = schools.find(d => d.id === st.schoolId);
      if (found) {
        st.schoolName = found.name;
      }
    });

    set_dataList(tempList);

    closeIndicator();
    */
  };

  const onDetail = async (id, gdnPhone) => {
    set_detailScreen(true);
    dgRef.current.open()
  };

  const onDelete = async id => {
    const url = '/student';
    openIndicator()
    const resp = await WebService.delete(url, { id: id });
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    onLoad();
    openSnackbar('삭제되었습니다.');
  };

  const handleSampleDownload= async ()=> {
    const serverUrl = encodeURI(`/student/download/tmpl`)
    const response = await axios.get(serverUrl, {
      responseType: 'blob', // Set responseType to 'blob' for binary data
    });
    console.log('response=>', response)
    //
    const contentDispositionHeader = response.headers['content-disposition'];
    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    const matches = filenameRegex.exec(contentDispositionHeader);
    let suggestedFilename = 'downloaded_file'; // Default filename if not found

    if (matches != null && matches[1]) {
      suggestedFilename = matches[1].replace(/['"]/g, ''); // Remove quotes if present
    }

    // Create a Blob object from the response data
    const blob = new Blob([response.data], { type: response.headers['content-type'] });

    // Create a temporary URL for the Blob
    const url = window.URL.createObjectURL(blob);

    // Create a link element to trigger the download
    const link = document.createElement('a');
    link.href = url;
    link.download = suggestedFilename
    document.body.appendChild(link);

    // Trigger the download
    link.click();

    // Clean up the temporary URL and link
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  }

  const handleStudentDownload = async () => {
    const students = await fetchStudents(-1, -1, JSON.stringify({})) 
    if(!students) {
      return
    }
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet(`${schola.name} 학생명단`)
    worksheet.columns = [
      { header: '학생명', key: 'name', width: 20 },
      { header: '학년', key: 'grade', width: 10 },
      { header: '반', key: 'className', width: 10 },
      { header: '번호', key: 'classNum', width: 10 },
      { header: '보호자전화번호', key: 'gdnPhone', width: 20 },
      { header: '자유수강권', key: 'ftYn', width: 10 },
    ];

    students.forEach((row,idx) => {
      worksheet.addRow(row)
    })
    
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${schola.name}_학생명단.xlsx`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    });
  }

  const onCreate = () => {
    const now = moment().format(dateFormat);
    const newRecord = {
      ...defRecord,
      schoolId: schola.id,
      stdId: -1,
      statCode:'S001',
      content:'',
      regTime: now,
      uptTime: now,
      schoolRltnList: [],
    };
    newRecord.gdn = {};
    newRecord.regiAndLectureList = [];
    recordRef.current = newRecord
    set_detailScreen(true);
    dgRef.current.open()
  };

  const onSearch = () => {
    const newPageInfo = {...pageInfo}
    newPageInfo.pageNum = 0
    set_pageInfo(newPageInfo)
  };

  const onClear = () => {
    const obj = {};
    Object.keys(terms).forEach(k => {
      obj[k] = '';
    });
    set_terms(obj);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      searchButtonRef.current.click();
    }
  };


  const handleChangePage = (event, newPage) => {
    set_pageInfo({ ...pageInfo, pageNum: newPage });
  };

  const handleChangeRowsPerPage = event => {
    const pageSize = parseInt(event.target.value, 10);
    set_pageInfo({ pageNum: 0, pageSize: pageSize });
  };

  const onCreateSample = async () => {
    const url = `/student/sample/${schola.id}`
    openIndicator()
    const resp = await WebService.post(url)
    closeIndicator()
    if(resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }

    alert('샘플 데이터를 생성하였습니다.')
    onLoad()

  }

  const TablePaginationActions = props => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = event => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = event => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = event => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = event => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label='first page'>
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label='previous page'>
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label='next page'>
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label='last page'>
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };

  useEffect(() => {
    onLoad();
  }, [pageInfo])

  useEffect(() => {
    if(curLocationRef.current.key !== location.key) {
      curLocationRef.current = location
      termsRef.current= defTerms
      Object.keys(searchRefMap).forEach(k => {
        if(searchRefMap[k].current) {
          searchRefMap[k].current.value = ''
          searchRefMap[k].current.checked = false
        }
      })
      set_pageInfo({ pageNum: 0, pageSize: 10 })
    }
  }, [location]) 


  useEffect(() => {
    const size = window.getComputedStyle(inputRef.current, null).getPropertyValue('font-size');

    set_fontSize(size);
  }, []);

  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  const Remark = () => {
    const [student, set_student] = useState({...recordRef.current})

    const onSubmit = async () => {
      const remark = student.remark.trim()
      
      const url = '/student'
      student.remark = remark
      const data = student
      openIndicator()
      const resp = await WebService.post(url, data)
      if(resp.repCode !== 'ack') {
        closeIndicator()
        alert(resp.repMessage)
        return
      }
      closeIndicator()
      openSnackbar('저장되었습니다.')
      remarkRef.current.close()
      set_pageInfo({...pageInfo})
    }
    return (
      <Grid container spacing={2}>
        <Grid item xs={12} style={{ fontWeight: 'bold' }}>
          <Typography style={{fontWeight:'bold'}}>{student.name}( {student.grade}/{student.className}/{student.classNum} )</Typography>
        </Grid>
        <Grid item xs={12}>
          {/* <Divider /> */}
        </Grid>
        <Grid item xs>
          <TextField
            rows={5}
            fullWidth
            multiline
            label={'비고'}
            defaultValue={student.remark}
            onChange={ e => {
              student.remark = e.target.value
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.stopPropagation(); // prevent form submit
              }
            }}
            inputProps={{ maxLength: 256 }}
          />
        </Grid>
        <Grid item xs={12} style={{display:'flex', justifyContent:'center'}}>
          <Button variant='outlined'
            style={{margin:5}}
            onClick={() => {remarkRef.current.close() }}
          >닫기</Button>
          <Button variant='contained'
            style={{margin:5}}
            onClick={onSubmit}
          >저장</Button>
        </Grid>
      </Grid>
    )
  }

  const dg_title = '학생 정보';
  const memo_DgContent = useMemo(() => {
    return <ManagerStudentPart fields={fields} record={recordRef.current} dgRef={dgRef} />;
  }, [recordRef.current])

  if (dataList != null) {
    return (
			<div ref={inputRef}>
				<MyDialog2
          ref={dgRef}
					title={dg_title}
					component=<ManagerStudentPart fields={fields} record={recordRef.current} dgRef={dgRef} callback={(updated) => {
						set_detailScreen(false)
            if(updated) {
              onLoad()
            }
          }} />
				/>

        <MyDialog2
          ref={remarkRef}
					title={'비고'}
          windowWidth='sm'
					component=<Remark fields={fields} record={recordRef.current} dgRef={remarkRef} />
				/>
				<ManagerStudentPart2 open={open} onClose={() => set_open(false)} reload={onLoad}/>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}>
          <div style={{ paddingRight: 10 }}>
            <h1>학생 관리 </h1>
          </div>
        </div>
				<div style={{ display: "flex", flexDirection: "row" }}>
          
					<Button sx={{ mr: 1, }} onClick={() => { onCreate() }}>
						생성
					</Button>
          <Button  startIcon={<FileUploadOutlinedIcon/>} variant='contained' component='span' sx={{ mr: 1}} onClick={() => {set_open(true)}} >
            학생전체목록 업로드(생성/수정/삭제)
          </Button>

          <Button startIcon={<FileDownloadOutlinedIcon/>} component='span' sx={{ mr: 1,}} onClick={handleSampleDownload} >
            샘플 파일 다운로드
          </Button>
          <Button startIcon={<FileDownloadOutlinedIcon/>}  component='span' sx={{ mr: 1,}} onClick={handleStudentDownload} >
            전체 학생 다운로드
          </Button>
          {/* {

            account && account.roleList.filter(r => r.roleCode === 'S002').length > 0 ? (
              <>
                <ConfirmDialog
                  btn={<Button variant='contained' color='success' component='span' sx={{ mr: 1 }}> 120명 샘플 학생/보호자 생성</Button>}
                  title={'알림'}
                  content={'테스트용 샘플 데이터를 생성합니다. 생성 하시겠습니까?'}
                  bc={'success'}
                  preHandle={ async () => {
                    return true
                  }}
                  perform={() => {
                    onCreateSample()
                  }}
                />
              </>

            ) : null
          } */}
				</div>
        <div style={{ paddingTop: 20 }}>
					<MUITable sx={{minWidth:1024}}>
						<MyTableHead>
							<TableRow>
								{fields.map((col, index) => {
									if (col.visible) {
										return (
											<TableCell key={index} align='center' sx={{width: col.width?? null}}>
												{col.placeholder}
												{col.canSrch ? (
                          col.field === 'ftYn' || col.field === 'gdnCertYn' ? (
                            <>
                              <br/>
                              <input type='checkbox' style={{width:20, height:20}}
                                ref = {searchRefMap[col.field]}
                                onChange={(e) => {
                                  if(col.field === 'ftYn') {
                                    if(e.target.checked) {
                                        termsRef.current.ftYn = 'Y'
                                    }
                                    else {
                                      delete termsRef.current.ftYn
                                    }
                                  }
                                  if(col.field === 'gdnCertYn') {
                                    if(e.target.checked) {
                                      termsRef.current.gdnCertYn = 'Y'
                                    }
                                    else {
                                      delete termsRef.current.gdnCertYn
                                    }
                                  }
                                }}
                              />
                            </>
                          ) : (
                            <Fragment>
                              <br />
                              <TextField
                                inputRef = {searchRefMap[col.field]}
                                label=''
                                variant='outlined'
                                size='small'
                                inputProps={{
                                  style: {
                                    fontSize: "0.875em",
                                    padding: 5,
                                    backgroundColor: "#fff",
                                  },
                                }}
                                // value={terms[col.field]}
                                onChange={(e) => {
                                  const newTerms = { ...termsRef.current }
                                  newTerms[col.field] = e.target.value
                                  termsRef.current = newTerms
                                  
                                  // set_terms(newTerms)
                                }}
                              />
                            </Fragment>
                          )
												) : (
													<Fragment>
														<br />
														<br />
													</Fragment>
												)}
											</TableCell>
										)
									}
								})}
								<TableCell size='small'>
									<br />
									<FlatButton ref={searchButtonRef} style={{ marginRight: 5, backgroundColor:'white' }} color='primary' onClick={onSearch}>
										검색
									</FlatButton>
								</TableCell>
							</TableRow>
						</MyTableHead>
						<TableBody>
							{dataList.map((row, index) => {
								return (
									<Fragment key={index} >
										<TableRow
											onClick={() => {
                        recordRef.current = row
											}}>
											{fields.map((col, index2) => {
												if (col.visible) {
													return (
                            <TableCell key={index2} align='center' >
                              {
                                col.field === 'remark' ? (
                                  <span style={{display:'flex', alignItems:'center'}}>
                                    <Typography variant='body2'>{truncate(row.remark, 30)}</Typography>
                                    <IconButton
                                      size='small'
                                      onClick={(e) => {
                                        remarkRef.current.open()
                                      }}
                                    >
                                    <EditOutlined />  
                                    </IconButton>
                                  </span>
                                ) : (
                                   <Typography variant='body2' fontWeight={col.field === 'name' ? 'bold' : 'normal'}>
                                    {row[col.field]}
                                  </Typography>
                                )
                              }
                             
                            </TableCell>
													)
												}
											})}
											<TableCell size='small'>
												<FlatButton variant='outlined' size='small' style={{ marginRight: 5 }} onClick={() => onDetail(row.id, row.gdnPhone)}>
													보기
												</FlatButton>
                        <ConfirmDialog
                          btn={<FlatButton color={'error'}>삭제</FlatButton>}
                          title={'주의'}
                          content={'학생의 수강데이터가 없는 경우에만 삭제됩니다. 삭제하시겠습니까?'}
                          bc={'error'}
                          preHandle={ async () => {
                            return true
                          }}
                          perform={() => {
                            onDelete(row.id)
                          }}
                        />
											</TableCell>
										</TableRow>
									</Fragment>
								)
							})}
						</TableBody>
						<TableFooter>
							<TableRow>
								<TablePagination
                  sx={{
                    [`& .${tablePaginationClasses.spacer}`]: {
                      display: "none"
                    },
                    [`& .${tablePaginationClasses.toolbar}`]: {
                      justifyContent: "center"
                    }
                  }}
                  rowsPerPageOptions={[10, 20, { label: "All", value: -1 }]}
									colSpan={visibleColumns.length + 1}
									count={totalCount}
									rowsPerPage={pageInfo.pageSize}
									page={pageInfo.pageNum}
									SelectProps={{
										inputProps: {
											"aria-label": "rows per page",
										},
										native: true,
									}}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
									ActionsComponent={TablePaginationActions}
									labelDisplayedRows={({ from, to, count }) => {
										// return '' + from + '-' + to + ' 개 ' + count
										return `${from} - ${to} of ${count}`
									}}
									labelRowsPerPage={"페이지당 갯수"}
								/>
							</TableRow>
						</TableFooter>
					</MUITable>

					{renderSnackbar()}
					{renderIndicator()}
					{renderAlert()}
          
					<dg_content />
        </div>
			</div>
		)
  }
};

export default ManagerStudentPage;
